import { Outlet } from 'react-router-dom';
import { QuickSwitcher } from '../features/profiles/QuickSwitcher';
import { DecorationRenderer } from '../themes/decoration/DecorationRenderer';
import { useActiveTheme } from '../themes/useActiveTheme';

// Shared chrome for kid-facing routes — the persistent profile switcher
// from plan/03 §B sits on every screen except home (which IS the picker).
// Also drives theme application: the active profile's theme tokens are
// written onto :root and its decoration (bespoke component or spec)
// mounts behind page content via <DecorationRenderer />.
export function KidLayout() {
  const theme = useActiveTheme();
  return (
    <>
      <DecorationRenderer
        decoration={theme.decoration}
        {...(theme.customDecoration ? { customDecoration: theme.customDecoration } : {})}
        themeKey={theme.key}
      />
      <Outlet />
      <QuickSwitcher />
    </>
  );
}
